import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import AjaxLoading from './AjaxLoading'

import { StaticPageService } from '../services/StaticPageService'

const StaticPage = ({ id }) => {
    const [ content, setContent] = useState('');
    const [ loading, setLoading ] = useState(true);

    useEffect(() => {
        async function fetchData() {
            setLoading(true)
            const { content } = await StaticPageService.getContent(id)
            setContent(content)
            setLoading(false)
        }

        fetchData()
    }, []);

    return <>
        {loading ? (
          <div style={{position: 'relative', minHeight: '10em'}} >
              <AjaxLoading />
          </div>
        ) : (
          <div className='page-body' dangerouslySetInnerHTML={{__html: content}} />
        )}
    </>
}

StaticPage.propTypes = {
    id: PropTypes.number,
}

export default StaticPage
